// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"a1e9266e","564":"b3268ff4","955":"b3268ff4"}[chunkId] + ".chunk.css";
};